/**
 * Format helpers.
 */

import { format, formatDistanceToNow } from 'date-fns';

const IDR = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
});

export function formatIDR(value) {
  if (value === null || value === undefined) return '-';
  return IDR.format(Number(value));
}

export function formatDate(value, pattern = 'dd MMM yyyy') {
  if (!value) return '-';
  try {
    return format(new Date(value), pattern);
  } catch {
    return '-';
  }
}

export function formatDateTime(value) {
  return formatDate(value, 'dd MMM yyyy HH:mm');
}

export function formatRelative(value) {
  if (!value) return '-';
  try {
    return formatDistanceToNow(new Date(value), { addSuffix: true });
  } catch {
    return '-';
  }
}

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

export function formatBytes(value) {
  if (value === null || value === undefined) return '-';
  const n = Number(value);
  if (!n) return '0 B';
  const i = Math.min(
    Math.floor(Math.log(n) / Math.log(1024)),
    BYTE_UNITS.length - 1
  );
  return `${(n / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${BYTE_UNITS[i]}`;
}

// Axis-sized rupiah: "Rp 1,25 M" (miliar) / "Rp 820 jt" (juta) / "Rp 5 rb". Axis ticks
// only: exact figures always use formatIDR.
export function formatIDRCompact(value) {
  if (value === null || value === undefined) return '-';
  const n = Number(value);
  const abs = Math.abs(n);
  const trim = (x) => String(Math.round(x * 100) / 100).replace('.', ',');
  if (abs >= 1e12) return `Rp ${trim(n / 1e12)} T`;
  if (abs >= 1e9) return `Rp ${trim(n / 1e9)} M`;
  if (abs >= 1e6) return `Rp ${trim(n / 1e6)} jt`;
  if (abs >= 1e3) return `Rp ${trim(n / 1e3)} rb`;
  return `Rp ${trim(n)}`;
}

